import { api } from "api/api";
import { AxiosError } from "axios";
import Usuario from "model/administracao/cadastro/Usuario";
import Indicador from "model/indicadores/Indicador";
import Processo from "model/indicadores/Processo";
import UnidadeOrganizacional from "model/indicadores/UnidadeOrganizacional";
import Page from "model/page/Page";
import Pageable from "model/page/Pageable";
import { DataTableFilterMeta } from "primereact/datatable";
import { BaseServiceCadastros } from "service/BaseServiceCadastros";
import { getFilters } from "utils/filterUtils";

class IndicadorService implements BaseServiceCadastros<Indicador> {

    pesquisar(page: Pageable, filters?: DataTableFilterMeta | null) {
        return new Promise<Page>((resolve, reject): void => {

            let url = `/indicador/pesquisar`;
            if (filters) {
                url += getFilters(filters)
            }
            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort,
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    consultar(id: number) {
        return new Promise<Indicador>((resolve, reject): void => {
            api
                .get(`/indicador/consultar/${id}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    incluir(indicador: Indicador) {
        return new Promise<Indicador>((resolve, reject): void => {
            let url = `/indicador/incluir`;
            api
                .post(url, indicador)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    editar(indicador: Indicador) {
        return new Promise<Indicador>((resolve, reject): void => {
            api
                .put(`/indicador/editar`, indicador)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    excluir(id: number) {
        return new Promise<void>((resolve, reject): void => {
            api
                .delete(`/indicador/excluir/${id}`)
                .then(() => resolve())
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getRelatorioApresentacao(filters?: DataTableFilterMeta | null) {
        let url = `/indicador/report/apresentacao`
        if (filters) {
            url += getFilters(filters)
        }
        return new Promise<string>((resolve, reject): void => {
            api
                .get(url, { responseType: 'arraybuffer' })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    proximoCodigo() {
        return new Promise<string>((resolve, reject): void => {
            api
                .get(`/indicador/proximoCodigo`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getUnidadesMedida() {
        return [
            { label: '%', value: 'P' },
            { label: 'KG', value: 'KG' },
            { label: 'R$', value: 'RS' },
            { label: "Litros", value: "LT" }
        ];
    }

    getTiposAcumuloValor() {
        return [
            { label: 'Total', value: 'TOTAL' },
            { label: 'Média', value: 'MEDIA' },
            { label: 'Máximo', value: 'MAXIMO' },
            { label: "Mínimo", value: "MINIMO" }
        ];
    }

    getValorConvertido(unidadeMedida: string | null, valor: number | null): string {
        if (valor == null) return "";
        if (unidadeMedida == null) return valor.toString();
        if (unidadeMedida === "P") {
            return `${valor.toFixed(2).replace(".", ",")} %`;
        }
        if (unidadeMedida === "KG") {
            return `${valor.toFixed(2).replace(".", ",")} Kg`;
        }
        if (unidadeMedida === "RS") {
            return `R$ ${valor.toFixed(2).replace(".", ",")}`;
        }
        if (unidadeMedida === "LT") {
            return `${valor.toFixed(2).replace(".", ",")} Litros`;
        }
        return valor.toString();
    }

    processos() {
        return new Promise<Array<Processo>>((resolve, reject): void => {
            let url = `/indicador/processos`;
            api
                .get(url)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    unidadesOrgan() {
        return new Promise<Array<UnidadeOrganizacional>>((resolve, reject): void => {
            let url = `/indicador/unidadesOrganizacionais`;
            api
                .get(url)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    usuarios() {
        return new Promise<Array<Usuario>>((resolve, reject): void => {
            let url = `/indicador/usuarios`;
            api
                .get(url)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getTiposMeta(): { label: string, value: string, simbolo: string }[] {
        return [
            { label: 'Maior ou igual', value: 'GTE', simbolo: '>=' },
            { label: 'Maior que', value: 'GT', simbolo: '>' },
            { label: 'Igual', value: 'E', simbolo: '=' },
            { label: 'Menor que', value: 'LT', simbolo: '<' },
            { label: 'Menor ou igual', value: 'LTE', simbolo: '<=' },
        ];
    }

    getTipoMeta(value: string): { label: string, value: string, simbolo: string } {

        return this.getTiposMeta().find((tipoMeta) => tipoMeta.value === value) || { label: '', value: '', simbolo: "" };
    }
}

export default IndicadorService;